import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import { collection, query, limit, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { DestImgData } from "../Constants";

const PackageWidget = () => {
  const navigate = useNavigate();
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const q = query(collection(db, "transportPackages"), limit(10));
        const querySnapshot = await getDocs(q);
        const data = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setPackages(data);
      } catch (error) {
        console.error("Error fetching packages for widget:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPackages();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (packages.length === 0) return null;

  return (
    <Box sx={{ mb: 4, mt: 2 }}>
      <Stack
        direction="row"
        alignItems="center"
        sx={{ mb: 3, justifyContent: 'center' }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600, mr: 2 }}>
          Featured Transport Packages
        </Typography>
        <Button
          variant="contained"
          size="small"
          onClick={() => navigate("/packages")}
          sx={{ fontWeight: 600, textTransform: "none" }}
        >
          View All
        </Button>
      </Stack>

      <Box
        sx={{
          display: "flex",
          overflowX: "auto",
          gap: 2,
          pb: 1,
          "&::-webkit-scrollbar": { display: "none" },
          msOverflowStyle: "none",
          scrollbarWidth: "none",
        }}
      >
        {packages.map((pkg) => {
          const destImgItem = DestImgData[pkg.destination?.toLowerCase()];
          const imageSrc = destImgItem?.img || destImgItem?.imgList?.[0];
          const currencySymbol = pkg.currency === "INR" ? "₹" : `${pkg.currency} `;
          const startingPrice = pkg.cabPricing?.[0]?.price;

          return (
            <Card
              key={pkg.id}
              sx={{
                minWidth: 160,
                maxWidth: 160,
                flexShrink: 0,
                borderRadius: 3,
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                cursor: "pointer",
                transition: "transform 0.2s",
                "&:hover": { transform: "scale(1.02)" },
              }}
              onClick={() => navigate(`/packages/${pkg.id}`)}
            >
              <CardMedia
                component="img"
                height="100"
                image={imageSrc}
                alt={pkg.destination}
                sx={{ objectFit: "cover" }}
              />
              <CardContent sx={{ p: 1.5 }}>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    mb: 0.5,
                  }}
                >
                  {pkg.title}
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{
                    display: "block",
                    mb: 1,
                    lineHeight: 1.2,
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    minHeight: "2.4em"
                  }}
                >
                  {pkg.route}
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  {/* <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem", lineHeight: 1, mb: 0.5 }}>
                    starting from:
                  </Typography> */}
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 700, color: "primary.main", lineHeight: 1.2 }}
                  >
                    {startingPrice ? `${currencySymbol}${startingPrice.toLocaleString()}` : "Price on Req"}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          );
        })}
      </Box>
    </Box>
  );
};

export default PackageWidget;
